export const PRODUCT_CATEGORIES = [
  {
    label: 'Equipo de maniobra y control industrial',
    short: 'Maniobra y control',
    slug: 'industrial-switchgear-and-control',
    legacySlug: 'equipo-de-maniobra-y-control-industrial',
  },
  {
    label: 'Equipos de protección',
    short: 'Protección',
    slug: 'protection-equipment',
    legacySlug: 'equipos-de-proteccion',
  },
  { label: 'Iluminación', short: 'Iluminación', slug: 'lighting', legacySlug: 'iluminacion' },
  {
    label: 'Accesorios eléctricos en general',
    short: 'Accesorios',
    slug: 'electrical-accessories',
    legacySlug: 'accesorios-electricos-en-general',
  },
  {
    label: 'Conductores de potencia y control',
    short: 'Conductores',
    slug: 'power-and-control-conductors',
    legacySlug: 'conductores-de-potencia-y-control',
  },
];

export const MAIN_NAV = [
  { label: 'Inicio', href: '/' },
  { label: 'Servicios', href: '/services' },
  { label: 'Productos', href: '/products', menu: 'products' },
  { label: 'Proyectos', href: '/projects', menu: 'projects' },
  { label: 'Nosotros', href: '/about' },
  { label: 'Contacto', href: '/contact' },
];
